import { bootstrapTreeSelect } from '@/component/treeSelect'

export const ReactTreeSelectComponent = (() => {
	const init = (scope?: HTMLElement) => {
		bootstrapTreeSelect(scope)
	}

	return { init }
})()
